export enum EFeatureCategory {
    Fundamentals = "Fundamentals",
    API = "API",
    Automations = "Automations",
    EmailMarketing = "Email_Marketing",
    PopUps = "Pop_Ups",
    Audience = "Audience",
    Reporting = "Reporting",
    Support = "Support",
    LandingPages = "Landing_Pages"
}
